<template lang="html">
    <div>
        <Card>
            <template v-slot:head>
                <h5>
                    Journal Section <span style="color:red; font-size:16px;  margin:0;">*</span>
                </h5>
            </template>
            <template v-slot:main>
                <form action="">
                    <div class="form-group">
                        <h6>Select the appropriate section for this submission (See Sections and Policies in <a href="#">About the Journal</a>).</h6>
                        <div class="form-group">
                            <label class="asterik" for="">Primary Section/E-Collection/Theme Issue</label>
                            <jselect :options="sections" :default-option="true" :label="'section'" :label-key="'title'" :value-key="'section_id'"></jselect>

                            <div class="">
                                <a href="#">View E-collection: Canada Health Infoway e-Collection Benefits Evaluation [Section Id: 817]</a>
                                <span>Section Policy</span>
                                <p>This is some placeholder text.</p>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="">Secondary Section(s)/Theme(s)</label>
                            <select class="form-control dropdown">
                                <option >Please Choose</option>
                                <option v-bind:value="section.section_id" v-for="section in sections">{{ section.title }}</option>
                            </select>
                            <div class="">
                                <a href="#">View E-collection: Canada Health Infoway e-Collection Benefits Evaluation [Section Id: 817]</a> <i class="fas fa-info-circle"></i> <br>
                                <a href="#">View E-collection: Canada Health Infoway e-Collection Benefits Evaluation [Section Id: 817]</a> <i class="fas fa-info-circle"></i> <br>
                                <a href="#">View E-collection: Canada Health Infoway e-Collection Benefits Evaluation [Section Id: 817]</a> <i class="fas fa-info-circle"></i>
                            </div>
                        </div>
                    </div>
                </form>
            </template>
        </Card>
    </div>
</template>

<script>
export default {
    props: [
        "sections"
    ],
    methods: {
        async getSections() {
            try {
                let result = await axios.get('/api/sections');

                this.sections = result.data;
            } catch (exception) {

            }
        }
    },
    created() {
        if (!this.sections) {
            this.getSections();
        }

        console.log('here');
    }
}
</script>

<style lang="css" scoped>
</style>
